import axios from 'axios';
import Cookies from 'js-cookie';
import BaseComponent from 'foundation/base-component';

const COOKIE_MAX_AGE = 2147483647;

class AntiForgeryTokenComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        if (!this.options.endpointUrl) {
            throw new Error('You must provide endpointUrl');
        }

        this.init();
    }

    init() {
        this.updateToken(this.getOldToken());
    }

    getOldToken() {
        return Cookies.get(this.options.cookieName);
    }

    updateToken(oldToken) {
        const url = `${this.options.endpointUrl}?oldCookieToken=${oldToken}`;

        axios
            .get(url)
            .then((response) => {
                const { formInputToken, cookieTokenValue } = response.data;

                this.refs.tokenInput.value = formInputToken;

                if (cookieTokenValue !== null) {
                    Cookies.set(this.options.cookieName, cookieTokenValue, { expires: COOKIE_MAX_AGE, secure: true });
                }
            });
    }
}

export default AntiForgeryTokenComponent;
